import {ActionType} from "../../model/actionTypes";
import {errorHandler} from "./auth";



interface insuranceObj {
    file: File,
    practice: string,
    patNum: string
}
interface apiModule {
    url : string,
    body: string,
    method : string,
    practices : []
}
interface updateBulkUser {
    userNums: string,
    practice: string
}

export const uploadInsurance = (obj: insuranceObj) => async (dispatch: Function, getState: Function, api: any) => {
    dispatch({ type: ActionType.LOADER, payload: true });
    try {
        const resp =  await api.post("openDental/insurance", obj, {isMultipart: true});
        dispatch({ type: ActionType.LOADER, payload: false });
        return resp;
    } catch (err) {
        dispatch({ type: ActionType.LOADER, payload: false });
        throw dispatch(errorHandler(err));
    }
};

export const manualApiCall = (obj: apiModule) => async (dispatch: Function, getState: Function, api: any) => {
    dispatch({ type: ActionType.LOADER, payload: true });
    try {
        const resp =  await api.post("openDental/manualApiCall", obj);
        dispatch({ type: ActionType.LOADER, payload: false });
        return resp;
    } catch (err) {
        dispatch({ type: ActionType.LOADER, payload: false });
        throw dispatch(errorHandler(err));
    }
};


export const getUsersByUserNums = (dataObj: any) => async (dispatch: Function, getState: Function, api: any) => {
    dispatch({ type: ActionType.LOADER, payload: true });
    try {
        const params = JSON.stringify(dataObj);
        const resp =  await api.get("openDental/getUsersByUserNums?params="+ params);
        dispatch({ type: ActionType.LOADER, payload: false });
        return resp;
    } catch (err) {
        dispatch({ type: ActionType.LOADER, payload: false });
        throw dispatch(errorHandler(err));
    }
};

export const updateBulkUser = (obj: updateBulkUser) => async (dispatch: Function, getState: Function, api: any) => {
    dispatch({ type: ActionType.LOADER, payload: true });
    try {
        const resp =  await api.post("openDental/updateBulkUser", obj);
        dispatch({ type: ActionType.LOADER, payload: false });
        return resp;
    } catch (err) {
        dispatch({ type: ActionType.LOADER, payload: false });
        throw dispatch(errorHandler(err));
    }
};


export const getProvidersByPractice = (practice: any) => async (dispatch: Function, getState: Function, api: any) => {
    dispatch({ type: ActionType.LOADER, payload: true });
    try {
        const resp =  await api.get("openDental/getProvidersByPractice?practice="+ practice);
        dispatch({ type: ActionType.LOADER, payload: false });
        return resp;
    } catch (err) {
        dispatch({ type: ActionType.LOADER, payload: false });
        throw dispatch(errorHandler(err));
    }
};

export const updateBulkProviders = (obj: updateBulkUser) => async (dispatch: Function, getState: Function, api: any) => {
    dispatch({ type: ActionType.LOADER, payload: true });
    try {
        const resp =  await api.post("openDental/updateBulkProviders", obj);
        dispatch({ type: ActionType.LOADER, payload: false });
        return resp;
    } catch (err) {
        dispatch({ type: ActionType.LOADER, payload: false });
        throw dispatch(errorHandler(err));
    }
};
